import { render, staticRenderFns } from "./afterOrderList.vue?vue&type=template&id=61cfce85&scoped=true"
import script from "./afterOrderList.vue?vue&type=script&lang=js"
export * from "./afterOrderList.vue?vue&type=script&lang=js"
import style0 from "./afterOrderList.vue?vue&type=style&index=0&id=61cfce85&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cfce85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61cfce85')) {
      api.createRecord('61cfce85', component.options)
    } else {
      api.reload('61cfce85', component.options)
    }
    module.hot.accept("./afterOrderList.vue?vue&type=template&id=61cfce85&scoped=true", function () {
      api.rerender('61cfce85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformOrderManagement/afterOrderList.vue"
export default component.exports